import { NgModule } from '@angular/core';
import { EmployeesComponent } from './employees.component';
import { RouterModule } from '@angular/router';
import { MatPaginatorModule } from '@angular/material/paginator';
import { AuthGuardService } from '../authentication/auth-guard.service';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { EmployeesDetailsComponent } from './employees-details/employees-details.component';
import { ReleasedEmployeesDetailsComponent } from './released-employees-details/released-employees-details.component';
import { LongLeaveEmployeesDetailsComponent } from './long-leave-employees-details/long-leave-employees-details.component';
import { EmployeesExperienceDetailsComponent } from './employees-experience-details/employees-experience-details.component';
import { PaginatorModule, MultiSelectModule, TabViewModule } from 'primeng/primeng';
import { TableModule } from 'primeng/table';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FuseWidgetModule } from '@fuse/components';
import { FuseModule } from '@fuse/fuse.module';
import { fuseConfig } from 'app/fuse-config';
import { MatButtonToggleModule, MatIconModule, MatTooltipModule } from '@angular/material';
import { SharedModule } from 'app/shared/shared.module';
import { InterviewInfoComponent } from './interview-info/interview-info.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DropdownModule } from 'primeng/dropdown';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';
import { HighchartsChartModule } from 'highcharts-angular';
import { MatCardModule } from '@angular/material/card';


const routes = [
  // { path: '', redirectTo: 'employees', pathMatch: 'full', canActivate: [AuthGuardService] },
  // { path: 'employees', component: EmployeesComponent, canActivate: [AuthGuardService] },
  { path: 'employees-details', component: EmployeesDetailsComponent, canActivate: [AuthGuardService] },
  { path: 'released-employees', component: ReleasedEmployeesDetailsComponent, canActivate: [AuthGuardService] },
  { path: 'long-leave-employees', component: LongLeaveEmployeesDetailsComponent, canActivate: [AuthGuardService] },
  { path: 'employees-experience-details', component: EmployeesExperienceDetailsComponent, canActivate: [AuthGuardService] },
  { path: 'interview-info', component: InterviewInfoComponent, canActivate: [AuthGuardService] }

];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    MatPaginatorModule,
    NgxChartsModule,
    PaginatorModule,
    TableModule,
    NgxSpinnerModule,
    MultiSelectModule,
    MatIconModule,
    FuseModule.forRoot(fuseConfig),
    FuseWidgetModule,
    TabViewModule,
    MatTooltipModule,
    SharedModule,
    MatDialogModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    DropdownModule,
    MatCheckboxModule,
    MatTabsModule,
    HighchartsChartModule,
    MatCardModule,
    MatButtonToggleModule
  ],
  declarations: [
    EmployeesComponent,
    ReleasedEmployeesDetailsComponent,
    LongLeaveEmployeesDetailsComponent,
    InterviewInfoComponent,
    EmployeesExperienceDetailsComponent,
    EmployeesDetailsComponent
  ],
})
export class EmployeesModule { }
